import { useScript } from "@bokio/hooks/useScript/useScript";

export const LinkedinAds = () => {
	useScript("scripts/LinkedinAds.js");

	return null;
};
